import './Settings.scss'
import ProfileLayout from '../components/ProfileLayout'

const Settings = () => {
  return <ProfileLayout id="settings" title="Settings" text=""></ProfileLayout>
}

export default Settings
